
//import FireworksComponent from "./background/fireworks-component";
import MatrixForegroundComponent from "./matrix/martix-foreground-component";
// import ScatterRespinComponent from "./matrix/scatter-respin-component";
import CoinPotsComponent from "./pots/coinpots-component";
import CoinpotsTexts from "./pots/coinpots-texts";
import JackpotComponent from "./jackpot/jackpot-component";
import FreespinsBigWinComponent from "./freespins/freespins-bigwin-component";
import {BigWinTierConfig} from "slotworks/config/component-config-schema";
import CelebrateWinMultiplierComponent from "./celebrate-win/celebrate-win-multiplier-component";
import PotLandEmitterComponent from "./celebrate-win/pot-land-emitter-component";
import ScatterWinComponent from "./jackpot/scatter-win-component";
import JackpotMeterComponent from "./jackpot/jackpot-meter-component";
//import FreespinTotalWin from "./celebrate-win/freespin-total-win";

// import Components
export default class DSComponents {
    
//    public static fireworks: FireworksComponent;
    public static matrixForeground: MatrixForegroundComponent;
//    public static scatterRespin: ScatterRespinComponent;
    public static coinPots: CoinPotsComponent;
    public static coinPotsTexts: CoinpotsTexts;
    public static jackpotComponent: JackpotComponent;
    public static freespinsBigWin: FreespinsBigWinComponent;
    public static celebrateWinMultiplier: CelebrateWinMultiplierComponent;
    public static potLandEmitter: PotLandEmitterComponent;
    public static scatterWin: ScatterWinComponent;
    public static jackpotMeter: JackpotMeterComponent;

    public static init() {
    //    this.fireworks = new FireworksComponent();
        this.matrixForeground = new MatrixForegroundComponent();
    //    this.scatterRespin = new ScatterRespinComponent();
        this.coinPots = new CoinPotsComponent();
        this.coinPotsTexts = new CoinpotsTexts();
        this.jackpotComponent = new JackpotComponent();
        this.freespinsBigWin = new FreespinsBigWinComponent();
        this.initFreespinsBigWin();
        this.celebrateWinMultiplier = new CelebrateWinMultiplierComponent();
        this.potLandEmitter = new PotLandEmitterComponent();
        this.scatterWin = new ScatterWinComponent();
        this.jackpotMeter = new JackpotMeterComponent();
    }
    

    // todo refactor
    public static initFreespinsBigWin() {
        const configs:BigWinTierConfig[] = [
            {
                "threshold": 15,
                "countTime": 3500,
                "waitTime": 3400,
                "scene": "freespins_bigWin"
            },
            {
                "threshold": 35,
                "countTime": 3100,
                "waitTime": 3000,
                "scene": "freespins_megaWin"
            },
            {
                "threshold": 60,
                "countTime": 2900,
                "waitTime": 3000,
                "scene": "freespins_superMegaWin"
            },
            {
                "threshold": 100,
                "countTime": 3500,
                "waitTime": 2600,
                "scene": "freespins_epicWin"
            }
        ];
        configs.forEach(element => {
            this.freespinsBigWin.addWinTier(element);    
        });
        
    }
}
